module.exports = __webpack_public_path__ + "static/media/tieadvanced.39e72192.png";